<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-tabs grow v-model="tab" hide-slider="true" selected-class="v-tab-selected" density="compact"
      class="mb-5 favorites-tabs">
      <v-row>
        <v-col md="6">
          <v-tab :text="$t('shop.favorite.title.favorites')" variant="text" :ripple="false" size="x-small">

          </v-tab>
        </v-col>
        <v-col md="6">
          <v-tab :text="$t('shop.favorite.title.requests')" variant="text" :ripple="false" size="x-small">

          </v-tab>
        </v-col>
      </v-row>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item :value="'Lieblingsmarken'">
        <v-card flat>
          <v-card-text v-if="favorites.length >= 1">
            <v-list>
              <v-list-item class="shop-favorite-entry mb-3 bg-white py-2" :value="index" :ripple="false"
                v-for="(item, index) in favorites" :key="index" @click="$router.push(`/fairling/${item.merchantId}/`)">
                <template v-slot:append>
                  <v-icon
                    :size="['xs', 'sm'].includes($globalState.screenWidth) ? 'small' : 64">mdi-chevron-right</v-icon>
                </template>
                <v-row align="center">
                  <v-col cols="4" md="2" lg="3" align="center" class="pa-0 pa-md-3">
                    <v-img :src="`${$cloudFrontApi}${item.avatar}/GALLERY_IPHONE6`" rounded="lg"></v-img>
                  </v-col>
                  <v-col cols="8" md="10" lg="9" class="shop-favorite-entry-content">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle class="mb-2">{{ item.tagline }}</v-list-item-subtitle>
                    <span class="my-2 mb-2"><img class="mr-1" :src="`/images/flags/flag_${item.country}.png`"
                        height="16" width="16">{{
                          item.country
                        }}</span><br>
                    <span v-html="$t('shop.favorite.added.favorites', {date: `${new Date(item.date).getDate()}. ${$getMonthName(new Date(item.date).getMonth() + 1)}. ${new Date(item.date).getFullYear()}`})"></span>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text v-else>
            <v-row class="mb-5" justify="center">
              <span>
                {{$t('shop.favorite.empty.message.favorites')}}
              </span>
            </v-row>
            <v-row justify="center">
              <v-btn variant="flat" size="large" color="primary" rounded="lg"
                class="white--text mb-2 find-favourites-button" @click="$router.push('/shop/home')">{{$t('shop.favorite.empty.button.favorites')}}</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tabs-window-item>
      <v-tabs-window-item :value="'Angefragte Hersteller'">
        <v-card flat>

          <v-card-text v-if="requested.length >= 1">
            <v-list>
              <v-list-item class="shop-favorite-entry mb-3 bg-white py-2" :value="index" :ripple="false"
                v-for="(item, index) in requested" :key="index" @click="$router.push(`/fairling/${item.merchantId}/`)">
                <template v-slot:append>
                  <v-icon
                    :size="['xs', 'sm'].includes($globalState.screenWidth) ? 'small' : 64">mdi-chevron-right</v-icon>
                </template>
                <v-row align="center">
                  <v-col cols="4" md="2" lg="3" align="center" class="pa-0 pa-md-3">
                    <v-img :src="`${$cloudFrontApi}${item.avatar}/GALLERY_IPHONE6`" rounded="lg"></v-img>
                  </v-col>
                  <v-col cols="8" md="10" lg="9" class="shop-favorite-entry-content">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle class="mb-2">{{ item.tagline }}</v-list-item-subtitle>
                    <span class="my-2 mb-2"><img class="mr-1" :src="`/images/flags/flag_${item.country}.png`"
                        height="16" width="16">{{
                          item.country
                        }}</span><br>
                    <span v-html="$t('shop.favorite.added.requests', {date: `${new Date(item.date).getDate()}. ${$getMonthName(new Date(item.date).getMonth() + 1)}. ${new Date(item.date).getFullYear()}`})"></span>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text v-else>
            <v-row class="mb-5" justify="center">
              <span>
                {{$t('shop.favorite.empty.message.requests')}}
              </span>
            </v-row>
            <v-row justify="center">
              <v-btn variant="flat" size="large" color="primary" rounded="lg"
                class="white--text mb-2 find-favourites-button" @click="$router.push('/shop/home')">{{$t('shop.favorite.empty.button.requests')}}</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-container>
</template>

<script>
import { getCurrentInstance, onMounted, ref } from 'vue';

export default {
  data() {
    return {
      tab: 'Lieblingsmarken',
    }
  },
  setup() {

    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");
    const softToken = localStorage.getItem("softToken");
    const favorites = ref([]);
    const requested = ref([]);
    const { proxy } = getCurrentInstance();

    const fetchFavorites = () => {
      // const obj = { uuid: this.item.id }
      proxy.$axios.get("shop/favorites", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
      }
      ).then(favoritesFetched)
        .catch()
    }

    const favoritesFetched = (response) => {
      favorites.value = response.data.data.FAVORITES;
      requested.value = response.data.data.REQUESTED;
    }

    onMounted(() => {
      fetchFavorites();
    })

    return {

      fetchFavorites,
      favoritesFetched,
      favorites,
      requested,

    };
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  width: 900px;
}


.v-tab-selected {
  text-decoration: underline;
}

.v-tab {
  font-size: 26px;
  font-weight: 800;
  font-family: Montserrat, sans-serif;
  letter-spacing: normal;
}

.v-btn.find-favourites-button {
  font-size: 14px;
  font-weight: 400;
}

.shop-favorite-entry .shop-favorite-entry-content .v-list-item-title,
.shop-favorite-entry .shop-favorite-entry-content .v-list-item-subtitle {
  font-weight: 600;
}

.shop-favorite-entry .shop-favorite-entry-content {
  color: rgb(var(--v-theme-primary));
  color: #52b8d3;
}
</style>
<style>
@media only screen and (max-width: 960px) {
  .favorites-tabs .v-tab {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
}

@media only screen and (min-width: 960px) {
  .favorites-tabs .v-tab {
    font-size: 26px !important;
    font-weight: 800 !important;
  }
}
</style>
